// Collection Names
export const USERS = "users";
export const ELIGIBILITY = "eligibility";
export const LEADS = "leads";
export const PHONES_CAPTURED = "phonescaptured";
// Roles
export const ROLE_COUNTRY_HEAD = "countryHead";
